/**
 * The Bauartklasse readout shown to the customer on step 6. Its values are the display text, which
 * is why it is not the generated `Bauartklasse`: that one is the wire enum (`BAK1`), this one is
 * what we print (`BAK I`). UI-only on purpose — the Sparte takes the three raw answers in
 * `BauartklasseFertighausgruppe` and derives the class itself, so this is never sent.
 */
export enum BauartklasseLabel {
  BakI = 'BAK I',
  BakII = 'BAK II',
  BakIII = 'BAK III',
  BakIV = 'BAK IV',
  BakV = 'BAK V',
  FhgI = 'FHG I',
  FhgII = 'FHG II',
  FhgIII = 'FHG III',
  FhgIV = 'FHG IV',
  FhgV = 'FHG V',
}
